export const Weather = (function () {
    'use strict';

    function init() {
        const apiKey = '2182b119d5b5485983f170802240310'; // Replace with your WeatherAPI.com API key
        const location = '40.8584,-73.8929'; // Coordinates for Bronx, NY
        const apiUrl = `https://api.weatherapi.com/v1/current.json?key=${apiKey}&q=${location}`;

        const weatherContainer = document.getElementById('weather-box');

        if (!weatherContainer) return; // Exit if the container isn't found

        fetch(apiUrl)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Weather data not available');
                }
                return response.json();
            })
            .then(data => {
                const tempFahrenheit = Math.round(data.current.temp_f); // Temperature in Fahrenheit
                const rainChance = data.current.precip_in; // Precipitation in inches (you can calculate rain %)
                const weatherIcon = data.current.condition.icon; // Weather icon

                // Update the DOM with weather info
                weatherContainer.innerHTML = `                    
                    <div class="weather-icon"><img src="${weatherIcon}" alt="Weather Icon"></div>
                    <p class="temperature">It's ${tempFahrenheit}°F At New York Botanical Garden With A ${rainChance}% Chance of Rain</p>
                `;
            })
            .catch(error => {
                console.error('Error:', error);
                weatherContainer.innerHTML = '<p>Weather data not available</p>';
            });
    }

    return {
        init: init,
    };
})();